import { createSelector } from '@reduxjs/toolkit';

export const rulesSelector = (state: ReduxState) => state.rulesReducer;
export const selectTemplateRepoId = createSelector(rulesSelector, (rules) => rules?.templateRespositoryId);
export const selectPrevTemplateRepoId = createSelector(rulesSelector, (rules) => rules?.prevTemplateRepositoryId);
